import { useEffect, useRef } from "react";
import { supabase } from "../lib/supabase";
import { BrandLockup } from "../components/BrandLockup";

/* 🔴 **AN ATHLETE WHO SIGNS IN HERE IS TOLD WHERE THEIR TRAINING IS — HIS RULE'S SECOND HALF.**
 *
 * *"the web app is only for coaches so the role needs to be automatically as coach, no choice for
 * the user"* (2026-09-18). Every account CREATED on the web becomes a coach; an account made on the
 * PHONE keeps whatever it is, so an athlete can sign in here with a perfectly good password — and
 * until this screen existed, `App.tsx` gated only on *"is there a session"* and handed them the
 * coach console: a roster of nobody, a library that is not theirs, and nothing anywhere saying they
 * were in the wrong place.
 *
 * ⚠️ **THE ANSWER IS A DOOR, NOT AN ERROR.** Nothing has gone wrong and nothing is their fault, so
 * this says where their training IS rather than what they may not do — and it offers the only two
 * actions that can help: sign out (to try the coach account they may also have) and the app itself.
 * A refusal with no way forward is the trap the codex names — *"a dead button with words on it"*.
 */
export function NotACoach() {
  const heading = useRef<HTMLHeadingElement>(null);

  /* 🔴 **EVERY ROUTE MOVES FOCUS ON ARRIVAL, AND THIS ONE DID NOT — caught by the night suite's
     own ruler, 2026-09-18, AFTER it had shipped to `main`.** A client-side navigation moves
     nothing by itself, so without this a keyboard user is left standing on a link that no longer
     exists — and the rail, which reads focus as its THIRD input, latches open because focus never
     left the thing that was clicked. That this screen is a dead end makes it MORE important, not
     less: it is where somebody arrives confused. */
  useEffect(() => { heading.current?.focus(); }, []);

  return (
    <main id="main" className="app-turned-away">
      <div className="ht-panel app-turned-away-card">
        <BrandLockup />
        <h1 className="ht-heading" tabIndex={-1} ref={heading}>
          coachwork on the web is for coaches
        </h1>
        <p className="ht-callout">
          Your training lives in the app on your phone — everything you log, your week and your
          progress are all there.
        </p>
        <p className="ht-callout">
          If you also coach, sign out and use your coach account.
        </p>
        <button
          type="button"
          className="ht-button"
          onClick={() => {
            void supabase.auth.signOut();
          }}
        >
          Sign out
        </button>
      </div>
    </main>
  );
}
